/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-11 17:15:54
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-23 13:58:42
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_terminal_performance_report\form\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';
import review from '../../display_auditing/form/index';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        actDetailCode: this.paramsProps.actDetailCode,
      },
    };
  },
  components: {
    review,
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'view') {
        this.formName = 'review';
        this.formConfig = {
          code: val.code,
          id: row.id,
        };
        this.modalConfig.title = '查看详情';
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('excute-list');
  },
};
